module.exports = __webpack_public_path__ + "img/coverImg.59bf9e4a.png";